import { render } from "./CalledsView.vue?vue&type=template&id=03950318&scoped=true"
import script from "./CalledsView.vue?vue&type=script&lang=js"
export * from "./CalledsView.vue?vue&type=script&lang=js"

import "./CalledsView.vue?vue&type=style&index=0&id=03950318&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03950318"]])

export default __exports__